/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountValidations { 
    /**
     * SaasInfra bootstrap role and attached permissions existence
     */
    saasinfra_bootstrap_role_permissions_present?: boolean;
    /**
     * Existence of s3 bucket
     */
    saasinfra_bucket_present?: boolean;
    /**
     * Existence of folders in s3 bucket
     */
    saasinfra_folders_in_bucket_present?: boolean;
    /**
     * S3 bucket expiration policy matches with the system config expiration policy
     */
    saasinfra_s3_expiration_days_correct?: boolean;
    /**
     * Expiration policy on usage folder in s3 bucket
     */
    saasinfra_s3_expiration_present?: boolean;
}

